// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"expand-horizontal"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2.5 5V19M21.5 5V19M17.25 12H6.75M15 15.5L18.5 12L15 8.50001M9 8.50001L5.5 12L9 15.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-expand-horizontal')
export default class ExpandHorizontalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'expand-horizontal',
    }
  }
}
